import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Navbar() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
      style={{ height: "80px" }}
    >
      <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img src="/logo_irm.png" alt="IRM Logo" className="h-12 w-auto" />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-10">
          <Link
            to="/"
            className={`font-medium transition-all relative cursor-pointer ${
              isScrolled ? "text-gray-800" : "text-white"
            } ${isActive("/") ? "after:w-full" : "after:w-0 hover:after:w-full"} after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:bg-orange-600 after:transition-all`}
            style={{ fontSize: "16px" }}
          >
            Inicio
          </Link>
          <Link
            to="/servicios"
            className={`font-medium transition-all relative cursor-pointer ${
              isScrolled ? "text-gray-800" : "text-white"
            } ${isActive("/servicios") ? "after:w-full" : "after:w-0 hover:after:w-full"} after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:bg-orange-600 after:transition-all`}
            style={{ fontSize: "16px" }}
          >
            Servicios
          </Link>
          <Link
            to="/nosotros"
            className={`font-medium transition-all relative cursor-pointer ${
              isScrolled ? "text-gray-800" : "text-white"
            } ${isActive("/nosotros") ? "after:w-full" : "after:w-0 hover:after:w-full"} after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:bg-orange-600 after:transition-all`}
            style={{ fontSize: "16px" }}
          >
            Nosotros
          </Link>
          <Link
            to="/contacto"
            className={`font-medium transition-all relative cursor-pointer ${
              isScrolled ? "text-gray-800" : "text-white"
            } ${isActive("/contacto") ? "after:w-full" : "after:w-0 hover:after:w-full"} after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:bg-orange-600 after:transition-all`}
            style={{ fontSize: "16px" }}
          >
            Contacto
          </Link>
        </div>

        {/* CTA Button */}
        <Link
          to="/contacto"
          className="hidden md:block px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white font-semibold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          Solicitar Servicio
        </Link>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
            isScrolled ? "text-gray-800" : "text-white"
          }`}
          aria-label="Toggle menu"
        >
          <i
            className={`${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}
          ></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-4">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block py-2 font-medium cursor-pointer ${
                isActive("/") ? "text-orange-600" : "text-gray-800"
              }`}
            >
              Inicio
            </Link>
            <Link
              to="/servicios"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block py-2 font-medium cursor-pointer ${
                isActive("/servicios") ? "text-orange-600" : "text-gray-800"
              }`}
            >
              Servicios
            </Link>
            <Link
              to="/nosotros"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block py-2 font-medium cursor-pointer ${
                isActive("/nosotros") ? "text-orange-600" : "text-gray-800"
              }`}
            >
              Nosotros
            </Link>
            <Link
              to="/contacto"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block py-2 font-medium cursor-pointer ${
                isActive("/contacto") ? "text-orange-600" : "text-gray-800"
              }`}
            >
              Contacto
            </Link>
            <Link
              to="/contacto"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block w-full px-6 py-3 bg-orange-600 text-white font-semibold rounded-full text-center cursor-pointer whitespace-nowrap"
            >
              Solicitar Servicio
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
